module.exports = __webpack_public_path__ + "img/product1.e6677691.png";